import { render, staticRenderFns } from "./landing-page.vue?vue&type=template&id=23b7fd7d&scoped=true"
import script from "./landing-page.vue?vue&type=script&lang=js"
export * from "./landing-page.vue?vue&type=script&lang=js"
import style0 from "./landing-page.vue?vue&type=style&index=0&id=23b7fd7d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b7fd7d",
  null
  
)

export default component.exports